<template>
  <div
    v-tooltip="$t('COMBINATION.SEND_EMAIL')"
    class="modal-icon"
    @click="emit('modal:show', $event, CommunicationType.email)"
  >
    <div class="flex h-full items-center justify-center">
      <icon-base :icon="IconEmail" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CommunicationType } from "@/enums/communicationLogs";

import IconEmail from "@/components/icons/IconEmail.vue";

const emit = defineEmits<{
  "modal:show": [MouseEvent, CommunicationType];
}>();
</script>
